
interface EventOverviewProps {
  description: string;
  client: string;
  duration: string;
  budget: string;
  guests: number;
  location: string;
}

export default function EventOverview({ description, client, duration, budget, guests, location }: EventOverviewProps) {
  const details = [
    { icon: 'ri-user-heart-line', label: 'Client', value: client },
    { icon: 'ri-time-line', label: 'Planning', value: duration },
    { icon: 'ri-group-line', label: 'Guests', value: `${guests}` },
    { icon: 'ri-map-pin-2-line', label: 'Venue', value: location },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-3 gap-14">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-px bg-emerald-400"></div>
              <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Overview</span>
            </div>
            <p className="text-stone-600 text-lg leading-relaxed">{description}</p>
          </div>
          <div className="space-y-5">
            {details.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4 p-4 bg-stone-50 rounded-xl">
                <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-emerald-600`}></i>
                </div>
                <div>
                  <p className="text-stone-400 text-xs font-medium uppercase tracking-wider">{item.label}</p>
                  <p className="text-stone-800 text-sm font-semibold mt-0.5">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
